// extracted by mini-css-extract-plugin
module.exports = {"root":"TabsSeo_root__PWp48","indicator":"TabsSeo_indicator__cTWFX","indicatorAnimated":"TabsSeo_indicatorAnimated__ypZyZ","tabSpacer":"TabsSeo_tabSpacer__mAzNG"};